import Vue from 'vue'
import App from './App.vue'
import router from './router/index';
import "./utils/imagePreview"
import './assets/global.scss';
Vue.config.productionTip = false
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import mytitle from './components/mytitle.vue';
import backCenter from './components/backCenter.vue';
import store from '@/store/index.js'
import xss from 'xss';

Vue.filter('cleanHtml', (value) => {
  return xss(value);
});
Vue.component('myTitle', mytitle)
Vue.component('backCenter', backCenter)
Vue.use(Element);
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
